import React from "react";

const Hero: React.FC = () => (
    <section className="hero" id="top">
        <div className="hero-bg">
            <div className="hero-grid" />
            <div className="hero-orb hero-orb-1" />
            <div className="hero-orb hero-orb-2" />
        </div>

        <div className="hero-content">
            <div className="hero-label">Israel's Premier IT Partner &mdash; Est. 2000+</div>

            <h1 className="hero-title">
                <span className="hero-title-line">Empowering Business</span>
                <span className="hero-title-line hero-title-accent">Through Technology</span>
            </h1>

            <p className="hero-tagline">
                Enterprise-grade IT solutions designed for forward-thinking companies.
                Cloud, security, infrastructure — scaled to your ambition.
            </p>

            <div className="hero-actions">
                <button className="btn-primary">Get Free Consultation</button>
                <button className="btn-ghost">View Our Services</button>
            </div>

            <div className="hero-rule" />
        </div>

        <div className="hero-scroll">
            <div className="scroll-line" />
        </div>
    </section>
);

export default Hero;
